import EGENCIA from './egencia.svg';
import HERTZ from './hertz.svg';
import TAXI from './taxi.svg';

export const Logos = { EGENCIA, HERTZ, TAXI };
